<template>
  <div class="verify-account">
    <illustration class="register" name="mailbox"></illustration>
    <div class="align-center">
      <div class="font-heading-30 mt-2">
        One last thing!
      </div>
      <p class="font-body-normal">We sent an email with a verification code to {{ email }}</p>
      <p class="font-body-normal">This code will expire in 15 minutes.</p>
      <div class="font-body-large mt-3">Enter your 5-digit code here:</div>
      <div class="mt-2">
        <k-otp
          @input="onChange"
          @complete="verifyAccount"
          v-model="verificationCode"
          :error="inCorrectCode ? true : false"
        />
        <p class="mt-1 error-message" v-if="inCorrectCode">
          {{ inCorrectCodeMessage}}
        </p>
        <button
            @click.prevent="verifyAccount"
            :disabled="!completed || loading"
            class="mt-3 btn btn-md btn-primary">
          Continue
        </button>
      </div>
      <div class="resend-verification">
        <p>Didn't get it?
          <span>
            <a @click.prevent="resendVerificationCode"
               href="#">Request new code.</a>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Illustration from '@components/illustration.vue';
import { axios } from '@utils';
import KOtp from '@components/inputs/otp.vue';

export default {
  name: 'verify-account',
  components: {
    Illustration,
    KOtp,
  },
  props: {
    email: String,
  },
  data() {
    return {
      loading: false,
      verificationCode: '',
      completed: false,
      inCorrectCodeMessage: '',
      inCorrectCode: false,
    };
  },
  methods: {
    onChange(value) {
      this.completed = value.length === 5;
    },
    verifyAccount() {
      this.loading = true;
      this.inCorrectCode = false;
      axios.put('/verify_user.json', { email: this.email.toLowerCase(), verification_code: this.verificationCode }).then((response) => {
        if (response.data.success && response.status === 200) {
          if (this.$route.path.includes('/childcare') && !this.$route.path.endsWith('/pay')) {
            window.location.href += this.$route.query.open_waitlist_form
              ? ''
              : `?action_after_login=${$('#registrationModal').data('action-after-login')}`;
          } else if (this.$route.path.endsWith('/pay')) {
            if (this.$route.query.is_checkout === 'true') {
              window.location.href = '/payments';
            } else if (this.$route.query.pr_id) {
              window.location.href = `${this.$route.path}/?pr_id=${this.$route.query.pr_id}`;
            } else {
              window.location.href = this.$route.path;
            }
          } else {
            window.location.href = '/';
          }
        } else if (response.data.message.length > 0) {
          this.inCorrectCode = true;
          this.inCorrectCodeMessage = response.data.message;
          this.loading = false;
        }
      });
    },
    onComplete(value) {
      this.verificationCode = value;
      this.completed = true;
      this.inCorrectCode = false;
    },
    async resendVerificationCode() {
      this.inCorrectCode = false;
      const redirectTo = this.$route.path.endsWith('/pay') ? '/payments' : this.$route.path;
      axios.put('/request_new_verification_code.json', { email: this.email.toLowerCase(), redirect_to: redirectTo }).then((response) => {
        if (response.data.success) {
          this.verificationCode = '';
          this.verificationCode = '';
          this.completed = false;
        } else {
          this.inCorrectCode = true;
          this.inCorrectCodeMessage = response.data.message;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.error-message {
  color: var(--rust-40);
}

.align-center {
  color: var(--gray-almostBlack);
}

.resend-verification {
  a {
    color: var(--sapphire-500) !important;
    padding-left: var(--grid-unit);
    text-decoration: auto;
  }

  font-size: var(--font-size-10);
  line-height: calc(var(--grid-unit) * 3);
  margin-top: calc(var(--grid-unit) * 2);
}

.register {
  background: none !important;
}

.verify-account {
  font-weight: 400;
}
</style>
